import { render, staticRenderFns } from "./ContactoModalEdicion.vue?vue&type=template&id=95ad5f0e&scoped=true&"
import script from "./ContactoModalEdicion.vue?vue&type=script&lang=ts&"
export * from "./ContactoModalEdicion.vue?vue&type=script&lang=ts&"
import style0 from "./ContactoModalEdicion.vue?vue&type=style&index=0&id=95ad5f0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ad5f0e",
  null
  
)

export default component.exports